"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiGrid2 = {
    styleOverrides: {
        root: {
            display: 'flex',
        },
        container: {
            width: 'unset',
            flex: '1 1 100%',
        },
    },
};
exports.default = muiGrid2;
//# sourceMappingURL=muiGrid2.js.map